import { AdminTeamMember, NewMember } from '@platform/client/schemas';
import { Button, Icon, Input } from '@platform/components';
import { useState } from 'react';

export const RemoveExistingMemberButton = ({
  teamMember,
  setRemoveMembers,
}: {
  teamMember: AdminTeamMember | NewMember;
  setRemoveMembers: React.Dispatch<
    React.SetStateAction<(AdminTeamMember | NewMember)[] | undefined>
  >;
}) => {
  return (
    <button
      onClick={() =>
        setRemoveMembers((prev) => {
          if (prev) {
            return [...prev, teamMember];
          } else {
            return [teamMember];
          }
        })
      }
    >
      <Icon type='x' />
    </button>
  );
};

export const RemovePendingNewMemberButton = ({
  pendingMemberId,
  setNewMembers,
}: {
  pendingMemberId: number;
  setNewMembers: React.Dispatch<React.SetStateAction<NewMember[] | undefined>>;
}) => {
  return (
    <button
      onClick={() => {
        setNewMembers((prev) => {
          if (prev) {
            return prev.filter((member) => member.id !== pendingMemberId) ?? undefined;
          } else {
            return prev;
          }
        });
      }}
    >
      <Icon type='x' />
    </button>
  );
};

export const UndoRemoveMemberButton = ({
  removedMemberId,
  setRemoveMembers,
}: {
  removedMemberId: number;
  setRemoveMembers: React.Dispatch<
    React.SetStateAction<(AdminTeamMember | NewMember)[] | undefined>
  >;
}) => {
  return (
    <button
      onClick={() =>
        setRemoveMembers((prev) => {
          if (prev) {
            return prev.filter((member) => member.id !== removedMemberId) ?? undefined;
          } else {
            return prev;
          }
        })
      }
    >
      <Icon type='refresh' />
    </button>
  );
};

export const AddMemberInputRow = ({
  setAddNewMemberId,
}: {
  setAddNewMemberId: React.Dispatch<React.SetStateAction<number | undefined>>;
}) => {
  const [draftMemberId, setDraftMemberId] = useState<number>();
  return (
    <div className='flex gap-2 items-center'>
      <Input
        placeholder='Enter user id'
        type='inline'
        value={draftMemberId ? draftMemberId.toString() : ''}
        onChange={(e) => setDraftMemberId(parseInt(e.target.value))}
      />
      <Button
        variant='secondary-color'
        size='sm'
        onPress={() => {
          setAddNewMemberId(draftMemberId);
        }}
        isDisabled={!draftMemberId}
      >
        Add
      </Button>
    </div>
  );
};
